export default "__VITE_ASSET__DK_gM4uV__"